import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import { SecurityService } from 'app/services/security/security.service';

@Component({
  selector: 'app-componentes',
  templateUrl: './componentes.component.html',
  styleUrls: ['./componentes.component.scss']
})
export class ComponentesComponent {
  abrirPopUpComponente: boolean = false;
  constructor(private loginService:LoginService,
    private router: Router,
    private securityService: SecurityService,) {
  }
  clickGuard(){
    this.loginService.clickGuard = true;
}
  AgregarComponente() {
    this.securityService.dataComponente = '';
    this.abrirPopUpComponente = true;
  }

  CerrarPopUpComponente() {
    this.abrirPopUpComponente = false;
  }
  Refresh() {
   this.router.navigate[("/componentes/listado")];
  }
}
